export const calculateCTR = ({ visits, impressions }) =>
  `${Math.round((visits / impressions) * 10000) / 100}%`
